import { PermissionI } from 'types';
import { create } from 'zustand';

type PermissionT = PermissionI & { assigned: boolean };

interface PermissionState {
  permissions: PermissionT[];
  /**
   * True once the permissions for the current user have been hydrated from
   * the backend at least once. Route guards must wait for this before
   * redirecting on missing permissions, otherwise the initial empty array
   * would kick every user out before the API responds.
   */
  loaded: boolean;
}

interface PermissionActions {
  setPermissions(permissions: PermissionT[]): void;
}

export const usePermissionStore = create<PermissionState & PermissionActions>()(set => ({
  permissions: [],
  loaded: false,
  setPermissions(permissions) {
    set(() => ({
      permissions,
      loaded: true,
    }));
  },
}));
